import { useGetUserCompanyQuery } from '@/features/user/userApi';
import { CompanyDetailForm } from '@/shared/components/CompanyDetailForm/CompanyDetailForm';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { useTranslation, withTranslation } from 'react-i18next';

const Company: React.FC = () => {
  const { t } = useTranslation();
  const { data: userCompanyData }: any = useGetUserCompanyQuery(undefined);
  const representedBusiness =
    userCompanyData && 'representedBusiness' in userCompanyData ? userCompanyData.representedBusiness : undefined;

  return (
    <SettingsViewWrapper name="company-page" title={t('settings.company_info')}>
      {userCompanyData ? <CompanyDetailForm company={representedBusiness} /> : <LoadingSpinner />}
    </SettingsViewWrapper>
  );
};

export default withTranslation()(Company);
